import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Pickers(_theme: Theme) {
  return {};
}
